import { withScope, captureException, captureMessage } from '@sentry/browser';
export const sendErrorToSentry = (options) => {
    const { error, config } = options;
    withScope((scope) => {
        if (config?.level)
            scope.setLevel(config.level);
        if (config?.extras)
            scope.setExtras(config.extras);
        if (config?.tags)
            scope.setTags(config.tags);
        captureException(error);
    });
};
export const sendMsgToSentry = (options) => {
    const { msg, config } = options;
    withScope((scope) => {
        if (config?.extras)
            scope.setExtras(config.extras);
        if (config?.tags)
            scope.setTags(config.tags);
        captureMessage(msg);
    });
};
//# sourceMappingURL=sendErrorToSentry.js.map